export default __webpack_public_path__ + "static/media/Adopt.5dcce241.png";